module.exports = __webpack_public_path__ + "static/img/fjdjt.38d9c4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/fjdjt.jpg
// module id = MUx3
// module chunks = 0